import constants from "../../core/constants";

class AbsPrice {
  constructor() {
    return this.transform;
  }

  transform(number) {
    return Math.abs(number / constants.currencyBy);
  }
}

const absPriceFnc = () => new AbsPrice();

export default absPriceFnc;



// WEBPACK FOOTER //
// ./src/filters/absPrice/absPrice.filter.js